import LoadingSmple from '__core/modules/components/LoadingSimple';
import { defaultConfig } from 'app/config/environment';
import { logoutBackoffice } from 'app/crud/auth.crud';
import * as authStore from 'app/store/ducks/auth.duck';
import store from 'app/store/store';
import { isInPublisher } from 'app/utils/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

export const LogoutPage = ({ hasAuthToken, logout }) => {
  const [redirectTo, setRedirectTo] = React.useState('');
  let baseUrl = defaultConfig.BASE_URL_;
  const lastChar = baseUrl.substr(-1); // Selects the last character

  if (lastChar !== '/') {
    baseUrl = `${baseUrl}/`;
  }

  React.useEffect(() => {
    const auth = store.getState().auth;
    setRedirectTo(isInPublisher(defaultConfig) ? '/' : auth.user?.referrer ? auth.user.referrer : '/');

    if (document.cookie.includes('PHPSESSID')) {
      document.cookie = 'PHPSESSID=10373160-ca49-11ee-a2ad-494f733b286f; Path=/;';
    }

    // Invalida la sesión en servidor ANTES de limpiar el store: logout() borra el
    // authToken que el interceptor necesita para autenticar el POST /logout. El logout
    // local corre SIEMPRE (finally) — incluso si el POST se cuelga (timeout en la crud) —
    // para no dejar al usuario atrapado aquí ni autenticado en local. El .catch final
    // consume el rechazo por timeout (evita un unhandled rejection).
    // Sesión por enlace: el JWT es de tangerine-ai-backoffice y revocarlo la cerraría también allí.
    const serverLogout = auth.isLinkSession ? Promise.resolve() : logoutBackoffice();
    serverLogout.finally(() => logout()).catch(() => {});
  }, []);

  React.useEffect(() => {
    // Solo redirigir cuando el logout esté completo (hasAuthToken=false) y tengamos URL destino
    if (!hasAuthToken && redirectTo) {
      window.location.href = redirectTo;
    }
  }, [hasAuthToken, redirectTo]);

  return <LoadingSmple title={'Cerrando sesión'} />;
};

LogoutPage.propTypes = {
  hasAuthToken: PropTypes.bool,
  logout: PropTypes.func.isRequired,
};

export default connect(({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }), authStore.actions)(LogoutPage);
